import { Navigate, useSearchParams } from 'react-router';
import { addIntegrationPath, INTEGRATION_KINDS } from '../integrations.paths';

/** `/integrations/add?kind=` from before each kind had its own tab (CLAUDE.md → Tabs are routes: moved URLs keep a redirect). */
export function MovedAddIntegrationRedirect() {
  const [searchParams] = useSearchParams();
  const kind = INTEGRATION_KINDS.find((candidate) => candidate === searchParams.get('kind')) ?? 'sms';
  return <Navigate to={addIntegrationPath(kind)} replace />;
}
